import { render, staticRenderFns } from "./VideoPlayerTwo.vue?vue&type=template&id=79264e56&"
import script from "./VideoPlayerTwo.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerTwo.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerTwo.vue?vue&type=style&index=0&id=79264e56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports